import { useNavigate, useParams } from 'react-router-dom';
import { CollectionCard, type Tab } from '../../InfoPageCards';
import { useDemoPageProps } from '../DemoPageContext';
import { DemoPageTabLayout } from '../DemoPageTabLayout';
import { ArchivedPresentations } from './ArchivedPresentations';
import { PresentationsTable } from './PresentationsTable';

const presentationsTabs: Tab<'presentations' | 'archive'>[] = [
  { id: 'presentations', label: 'Presentations' },
  { id: 'archive', label: 'Archived' },
];

export const PresentationsTab = () => {
  const { innerTabId } = useParams<{
    innerTabId?: 'archive';
  }>();

  const tid = innerTabId || 'presentations';
  const navigate = useNavigate();

  const { rootPath } = useDemoPageProps();

  return (
    <DemoPageTabLayout>
      <div className="pb-10">
        <CollectionCard
          currentTabId={tid}
          setTab={(tabId) => {
            if (tabId === 'presentations') {
              navigate(`${rootPath}/presentations`);
            }
            if (tabId === 'archive') {
              navigate(`${rootPath}/presentations/archive`);
            }
          }}
          tabs={presentationsTabs}
          withSearch
          inputPlaceholder="Search for presentation name"
        >
          <>
            {tid === 'presentations' && <PresentationsTable />}
            {tid === 'archive' && <ArchivedPresentations />}
          </>
        </CollectionCard>
      </div>
    </DemoPageTabLayout>
  );
};
